import React from "react";
import CountUp from "react-countup";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import Grid from "@mui/material/Grid";
import styles from "./hero.module.scss";

export const UniPageQualityHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={12} md={6}>
            <h1 className={styles.title}>Simplifying Student Recruitment</h1>
            <p className={`${styles.sub_title} font-medium`}>
              The international student market is an ocean - and your university
              might be casting a net into just a tiny corner of it. Meet and
              surpass your recruitment goals by accessing our active pool of
              best-fit students from emerging student markets and boost
              conversion rates!
            </p>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university/booking">
                <a className="btn btn-bg btn-secondary">Book for Demo</a>
              </Link>
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/students_with_hat.png")}
                alt="University students"
              />
            </div>
          </Grid>
        </Grid>
        <div className={styles.counter_wrapper}>
          <ul>
            <li>
              <div className={styles.text1}>Current</div>
              <div className={styles.text2}>service levels</div>
            </li>
            <li>
              <div className={styles.number}>
                <CountUp end={96} duration={2} />%
              </div>
              <div className={styles.text}>Application To Offer Rate</div>
            </li>
            <li>
              <div className={styles.number}>
                <CountUp end={94} duration={2} />
                %+
              </div>
              <div className={styles.text}>Global Visa Success Rate</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default UniPageQualityHero;
